const Translations = {
    ViewInSpanish: {
        english: "Ver en Español",
        spanish: "View in English",
    },
    DownloadPDF: {
        english: "Download PDF",
        spanish: "Descargar PDF",
    },
    Title: {
        english:
            "D3 LLC Employee Accident Policy and Standard Operating Procedure",
        spanish:
            "Política de accidentes de empleados y procedimiento operativo estándar de D3 LLC",
    },
    Subtitle: {
        english:
            "The purpose of this policy is to outline and clarify the Policy of D3 LLC and it's subsidiaries as it pertains to the proper addressing and reporting of Employee Incidents and Accidents.",
        spanish:
            "El propósito de esta política es delinear y aclarar la Política de D3 LLC y sus subsidiarias en lo que respecta al tratamiento y reporte adecuado de incidentes y accidentes de empleados.",
    },
    ListHeader: {
        english:
            "Pursuant to the company goal of maintaining a safe and secure workplace for it's employees",
        spanish:
            "De acuerdo con el objetivo de la empresa de mantener un lugar de trabajo seguro y protegido para sus empleados",
    },
    ListItem1: {
        english:
            "All D3 employees are Required to report any accidents or incidents that occur on D3 property, during their normal working hours and throughout the course of their normal workday activities or otherwise, to their manager or supervisor ",
        spanish:
            "Todos los empleados de D3 están obligados a informar cualquier accidente o incidente que ocurra en la propiedad de D3, durante sus horas normales de trabajo y en el transcurso de sus actividades normales de la jornada laboral o de otro modo, a su gerente o supervisor ",
    },
    Immediately: {
        english: "IMMEDIATELY",
        spanish: "INMEDIATAMENTE",
    },
    ListItem2_pt1: {
        english: "The supervisor will assess the accident ",
        spanish: "El supervisor evaluará el accidente ",
    },
    ListItem2_pt2: {
        english: "and assist the injured employee with ",
        spanish: "y ayudará al empleado lesionado ",
    },
    ListItem2_pt3: {
        english: "seeking medical assistance, ",
        spanish: "a buscar asistencia médica, ",
    },
    ListItem2_pt4: {
        english: "and will also ",
        spanish: "y también ",
    },
    ListItem2_pt5: {
        english: "notify our Corporate Social Responsibility Coordinator. ",
        spanish:
            "notificará a nuestro Coordinador de Responsabilidad Social Corporativa. ",
    },
    ListItem3_pt1: {
        english:
            "It shall be the policy of D3, LLC that all incidents involving an injury, an Incident Report shall be completed by the employee with the assistance of their supervisor ",
        spanish:
            "La política de D3, LLC es que, en caso de cualquier accidente, el empleado, con la ayuda de su supervisor, complete un Informe de Incidentes ",
    },
    ListItem3_pt2: {
        english:
            "following occurrence. (Incident Report Forms are available on D3 Connect.) Once an accident has been reported, the supervisor may allow work in the department to resume. ",
        spanish:
            "después de que ocurra. (Los formularios de Informe de Incidentes están disponibles en D3 Connect). Una vez reportado el accidente, el supervisor podrá permitir que se reanude el trabajo en el departamento. ",
    },
    ListSubheader: {
        english:
            "Work cannot continue if an accident report has not been submitted.",
        spanish:
            "El trabajo no puede continuar si no se presenta un informe del accidente.",
    },
    ListItem4_pt1: {
        english: "The Supervisor ",
        spanish: "El supervisor ",
    },
    ListItem4_pt2: {
        english: "must then make sure that the ",
        spanish: "debe asegurarse de que ",
    },
    ListItem4_pt3: {
        english: "Human Resources Manager ",
        spanish: "el gerente de Recursos Humanos ",
    },
    ListItem4_pt4: {
        english: "or designee, ",
        spanish: "o su designado, ",
    },
    ListItem5_pt5: {
        english:
            "Chief Executive Officer, Chief Operating Officer, President of D3 and CSR Coordinator ",
        spanish:
            "el director ejecutivo (CEO), el director de operaciones (COO), el Presidente de D3 y el coordinador de RSE (De Seguridad) ",
    },
    ListItem4_pt6: {
        english: "are made aware of the incident immediately (via email to ",
        spanish:
            "sean informados del incidente de inmediato (por correo electrónico a ",
    },
    ListItem4_pt7: {
        english: "). As well as call the ",
        spanish: "). Además, debe llamar ",
    },
    ListItem4_pt8: {
        english: "Chief Operating Officer or President ",
        spanish: "al director de operaciones (COO) o al presidente ",
    },
    ListItem4_pt9: {
        english: "as soon as possible.",
        spanish: "lo antes posible.",
    },
    ListItem5: {
        english:
            "Human Resources will forward any/all reports involving an agency worker to the temp agency on behalf of the worker in the case that the incident involves a temp agency worker.",
        spanish:
            "Recursos Humanos enviará todos los informes que involucren a un trabajador de la agencia a la agencia de empleados temporales en nombre del trabajador en el caso de que el incidente involucre a un trabajador de la agencia de empleados temporales.",
    },
    ListItem6: {
        english:
            "A Workers Compensation case for an employee will be initiated by HR as needed.",
        spanish:
            "El departamento de Recursos Humanos iniciará un caso de compensación laboral para un empleado según sea necesario.",
    },
    ListItem7: {
        english:
            "Human Resources will also ensure proper reporting of incident/accident on the OSHA 300 Log and OSHA Form 301.",
        spanish:
            "Recursos Humanos también garantizará la correcta notificación de incidentes/accidentes en el Registro OSHA 300 y el Formulario OSHA 301.",
    },
    ListItem8: {
        english:
            "These reports will be reviewed on an on-going basis by the Safety Team to determine the cause and effect of the injury, and to develop preventive measures to help avoid future occurrences.",
        spanish:
            "El Equipo de Seguridad revisará estos informes de forma continua para determinar la causa y el efecto de la lesión y para desarrollar medidas preventivas que ayuden a evitar que vuelva a ocurrir.",
    },
    ListItem9_pt1: {
        english:
            "In cases where the employee requires medical intervention, the supervisor will",
        spanish:
            "En los casos en que el trabajador requiera intervención médica, el supervisor deberá",
    },
    ListItem9_pt2: {
        english: "For D3 Employees",
        spanish: "Para Empleados de D3",
    },
    ListItem9_pt3: {
        english:
            "Provide D3's recommended information sheet to the worker, which includes our company's worker compensation provider information.",
        spanish:
            "Proporcionar la hoja de información recomendada de D3 al trabajador, que incluye la información del proveedor de compensación laboral de nuestra empresa.",
    },
    ListItem9_pt4: {
        english: "For Agency Workers",
        spanish: "Para Empleados Temporales de la Agencia",
    },
    ListItem9_pt5: {
        english:
            "The agency will contact the agency worker directly regarding worker's compensation case.",
        spanish:
            "La agencia se comunicará directamente con el trabajador de la agencia con respecto al caso de compensación laboral.",
    },
    ListItem10: {
        english:
            "The Manager or Supervisor taking the report should be prepared to assess the critical nature of the injury, and encourage and assist the employee in seeking medical treatment if necessary.",
        spanish:
            "El gerente o supervisor que tome el informe debe estar preparado para evaluar la naturaleza crítica de la lesión y alentar y ayudar al empleado a buscar tratamiento médico si es necesario.",
    },
    ListItem11_pt1: {
        english:
            "ANY INJURY THAT REQUIRES EMERGENCY MEDICAL CARE SHOULD BE LEFT TO CERTIFIED PERSONNEL. THE FOLLOWING PHONE NUMBERS WILL ACCESS",
        spanish:
            "CUALQUIER LESIÓN QUE REQUIERA ATENCIÓN MÉDICA DE EMERGENCIA DEBE SER ATENDIDA POR PERSONAL CERTIFICADO. LOS SIGUIENTES NÚMEROS DE TELÉFONO SON DE ATENCIÓN",
    },
    ListItem11_pt2: {
        english: "MELVILLE EMERGENCY FIRE AND AMBULANCE",
        spanish: "DEPARTAMENTO DE FUEGO Y AMBULANCIA DE MELVILLE",
    },
    ListItem11_pt3: {
        english: "POISON CONTROL HOTLINE",
        spanish: "LÍNEA DIRECTA DE CONTROL DE INTOXICACIONES",
    },
    ListItem12: {
        english:
            "Visitors & Guests - In the event that a visitor to D3 or a guest injured him/herself, please follow the same procedure. However, indicate on the report form why the individual is on D3 premises at the time of the incident.",
        spanish:
            "Visitantes e invitados: En caso de que un visitante o invitado de D3 se lesione, por favor` siga el mismo procedimiento. Sin embargo, indique en el formulario de informe el motivo por el cual la persona se encontraba en las instalaciones de D3 en el momento del incidente.",
    },
    RequiredToBeFilled: {
        english: "Required to be filled",
        spanish: "Requerido completar",
    },
    FillLater: {
        english: "Can be filled in later",
        spanish: "Se puede completar más tarde.",
    },
    EmployeeInfo: {
        english: "Employee Information",
        spanish: "Información Del Empleado.",
    },
    Involved: {
        english: "Who was involved in the accident?",
        spanish: "¿Quién estuvo involucrado en el accidente?",
    },
    HomePhone: {
        english: "Home Telephone #",
        spanish: "Número de teléfono de casa",
    },
    CellPhone: {
        english: "Cell Phone #",
        spanish: "Número de teléfono celular",
    },
    DateOFBirth: {
        english: "Date Of Birth:",
        spanish: "Fecha de nacimiento:",
    },
    Employment: {
        english: "Employment:",
        spanish: "Empleo:",
    },
    Incident: {
        english: "Incident Information",
        spanish: "Información Del Incidente",
    },
    Witness: {
        english: "Witness:",
        spanish: "Testigo:",
    },
    WorkerTitle: {
        english: "Worker Title:",
        spanish: "Título Del Trabajador:",
    },
    Location: {
        english: "Location of incident:",
        spanish: "Ubicación del incidente:",
    },
    TimeOfAccident: {
        english: "Time Of Accident",
        spanish: "Hora Del Accidente",
    },
    Date: {
        english: "Date:",
        spanish: "Fecha:",
    },
    Time: {
        english: "Time:",
        spanish: "Hora:",
    },
    Building: {
        english: "Building:",
        spanish: "Edificio:",
    },
    EmployeeWorkHours: {
        english: "Employee Work Hours",
        spanish: "Horas De Trabajo De Los Empleados",
    },
    From: {
        english: "From:",
        spanish: "De:",
    },
    To: {
        english: "To:",
        spanish: "A:",
    },
    InjuryDetails: {
        english: "Injury Details",
        spanish: "¿Cómo se lastimó?",
    },
    NumberOfInjury: {
        english: "Number Of Injury:",
        spanish: "El Número De Lesiones",
    },
    Injury: {
        english: "Injury:",
        spanish: "lesión",
    },
    NatureOfInjury: {
        english: "Nature Of Injury:",
        spanish: "Tipo De Lesión:",
    },
    InjuryList: {
        english: [
            "",
            "FRACTURE",
            "BURN (Included: Chemical Burn)",
            "AMPUTATION",
            "WOUND / CUT",
            "STING , PRICK",
            "CONTUSION",
            "SPRAIN",
            "FOREIGN BODY",
            "PAIN BY EFFORT, LUMBAGO",
            "ASPHYXIA",
            "ELECTRIFICATION",
            "FAINT",
            "OTHER",
        ],
        spanish: [
            "",
            "FRACTURA",
            "QUEMADURA (Incluida: Quemadura Química)",
            "AMPUTACIÓN",
            "HERIDA / CORTE",
            "PICADURA, PINCHAZO",
            "CONTUSIÓN",
            "ESGUINCE",
            "CUERPO EXTRAÑO",
            "DOLOR POR ESFUERZO, LUMBAGO",
            "ASFIXIA",
            "ELECTRIZACIÓN",
            "DESMAYO",
            "OTRO",
        ],
    },
    ExplainOther: {
        english: "Explain Other Nature Of Injury:",
        spanish: "Explique Otra Naturaleza De La Lesión:",
    },
    PleaseExplain: {
        english: "Please Explain:",
        spanish: "Por Favor Explica:",
    },
    BodyPartsAffected: {
        english: "Body Parts Affected:",
        spanish: "Las Partes Del Cuerpo:",
    },
    BodyParts: {
        english: [
            "",
            "HEAD (excluding eyes)",
            "EYES",
            "TRUNK",
            "BACK",
            "UPPER LIMBS (excluding hands)",
            "HANDS",
            "LOWER LIMBS (excluding feet)",
            "FEET",
            "NONE",
            "OTHER",
        ],
        spanish: [
            "",
            "CABEZA (excluyendo ojos)",
            "OJOS",
            "TRONCO",
            "ESPALDA",
            "EXTREMIDADES SUPERIORES (excluyendo manos)",
            "MANOS",
            "EXTREMIDADES INFERIORES (excluyendo pies)",
            "PIES",
            "NINGUNO",
            "OTRO",
        ],
    },
    OtherBodyPartsAffected: {
        english: "Explain Other Body Parts Affected:",
        spanish: "Otras Partes Del Cuerpo Afectadas:",
    },
    MedicalTreatment: {
        english: "Medical Treatment",
        spanish: "Tratamiento Médico",
    },
    TransportedToHospital: {
        english: "Transported To Hospital:",
        spanish: "¿Cómo Te Trasladaron Al Hospital?",
    },
    TransportOptions: {
        english: [
            "Ambulance",
            "Private Vehicle",
            "Not transported to the hospital",
        ],
        spanish: [
            "Ambulancia",
            "Vehículo Privado",
            "No transportado al hospital",
        ],
    },
    MedicalTreatment: {
        english: "Medical Treatment",
        spanish: "Tratamiento Médico",
    },
    TypeOfTreatment: {
        english: "Type Of Treatment",
        spanish: "Tipo De Tratamiento",
    },
    NameOfDoctor: {
        english: "Name Of Treating Doctor or Hospital:",
        spanish: "Médico O Hospital Que Realiza El Tratamiento:",
    },
    AddressOfDoctor: {
        english: "Address/Phone Number Of Doctor/Hospital:",
        spanish: "Dirección/Número De Teléfono De El Médico/Hospital:",
    },
    LeaveWork: {
        english: "Leave Work",
        spanish: "Dejar El Trabajo",
    },
    WhatTime: {
        english: "If So What Time:",
        spanish: "Si Es Así, ¿A Qué Hora:",
    },
    SelectTime: {
        english: "Select Time",
        spanish: "Seleccionar Hora",
    },
    IncidentDescription: {
        english: "Incident Description",
        spanish: "Descripción Del Incidente",
    },
    Before: {
        english: "Before:",
        spanish: "Antes:",
    },
    During: {
        english: "During:",
        spanish: "Durante:",
    },
    WhatLedUp: {
        english: "What led up to the incidient? (job description, surroundings, hazards)",
        spanish: "¿Qué ocurrió antes del incidente? (descripción del trabajo, entorno, peligros)",
    },
    WhatHappenedWhile: {
        english: "What happened while the incident was actively occuring? (accident details, pain, severity)",
        spanish: "¿Qué ocurrió mientras el incidente estaba ocurriendo? (detalles del accidente, dolor, gravedad)",
    },
     After: {
        english: "After:",
        spanish: "Después:",
    },
    WhatTookPlace: {
        english: "What took place once the accident transpired? (reporting procedure, treatment, follow up)",
        spanish: "¿Qué ocurrió después de que sucedió el accidente? (procedimiento de reporte, tratamiento, seguimiento)",
    },
    Equipment: {
        english: "Equipment/Material/Chemical",
        spanish: "Equipo/Material/Químico",
    },
    ProperProcedure: {
        english: "Used Proper Procedure",
        spanish: "Se utilizó el procedimiento adecuado",
    },
     IfNotExplain: {
        english: "If not, explain:",
        spanish: "Si no, explique:",
    },
     WearingPPE: {
        english: "Wearing PPE",
        spanish: "Uso de PPE:",
    },
    Explanation: {
        english: "Explanation",
        spanish: "Explicación",
    },
     TimeLost: {
        english: "Time Lost",
        spanish: "Tiempo perdido",
    },
    Days: {
        english: "Days:",
        spanish: "Días:",
    },
    Hours: {
        english: "Hours:",
        spanish: "Horas:",
    },
     ReportedTo: {
        english: "Reported To",
        spanish: "Reportado a",
    },
     DegreeOfInjury: {
        english: "Degree Of Injury",
        spanish: "Grado de la lesión",
    },
      InvolvedAlert: {
        english: "Who was involved in the accident is required field!",
        spanish: "¡Debe indicar quién estuvo involucrado en el accidente!",
    },
        EmploymentAlert: {
        english: "Employement is required field!",
        spanish: "¡El campo 'Empleo' es obligatorio!",
    },
       WitnessAlert: {
        english: "Witness is required field!",
        spanish: "¡El campo 'Testigo' es obligatorio!",
    },
    LocationAlert: {
        english: "Location of incident is required field!",
        spanish: "¡El campo 'Ubicación del incidente' es obligatorio!",
    },
    IncidentAlert: {
        english: "Date of incident is required field!",
        spanish: "¡El campo 'Fecha del incidente' es obligatorio!",
    },
    IncidentTimeAlert: {
        english: "Time of accident is required field!",
        spanish: "¡El campo 'Hora del accidente' es obligatorio!",
    },
    BuildingAlert: {
        english: "Please select the Building!",
        spanish: "¡Por favor, seleccione el edificio!",
    },
    InjuryNatureAlert: {
        english: "Please provide the nature of injury!",
        spanish: "¡Por favor, indique la naturaleza de la lesión!",
    },
    BodyPartAlert: {
        english: "Body part affected field is required!",
        spanish: "¡El campo 'Parte del cuerpo afectada' es obligatorio!",
    },
    TreatmentTypeAlert: {
        english: "Type of treatment is required field!",
        spanish: "¡El campo 'Tipo de tratamiento' es obligatorio!",
    },
    DoctorAlert: {
        english: "Name Of Treating Doctor or Hospital is required!",
        spanish: "¡El campo 'Nombre del médico tratante o del hospital' es obligatorio!",
    },
    TransportedAlert: {
        english: "Transported To Hospital is required field!",
        spanish: "¡El campo 'Traslado al hospital' es obligatorio!",
    },
    AccidentDescAlert: {
        english: "All Accident Description fields are required!",
        spanish: "¡Todos los campos de la descripción del accidente son obligatorios!",
    },
    EquipmentAlert: {
        english: "Equipment/Material/Chemical is required field!",
        spanish: "¡El campo 'Equipo/Material/Químico' es obligatorio!",
    },
     ProcedueAlert: {
        english: "Used Proper Procedure is required field!",
        spanish: "¡El campo 'Se utilizó el procedimiento adecuado' es obligatorio!",
    },
     PPEAlert: {
        english: "Wearing PPE is required field!",
        spanish: "¡El campo 'Uso de EPP' es obligatorio!",
    },
    InjuryDegreeAlert: {
        english: "Degree Of Injury is required!",
        spanish: "¡El campo 'Grado de la lesión' es obligatorio!",
    },





};

export function filterTranslations(userLanguage) {
    const validLanguages = ["english", "spanish"];
    const language = validLanguages.includes(userLanguage)
        ? userLanguage
        : "english";

    const filtered = {};

    for (const key in Translations) {
        if (Translations[key][language]) {
            filtered[key] = Translations[key][language];
        }
    }

    return filtered;
}
